// Microsoft 4-tile mark — official, do not recolor.
// Sourced from for-engineering-auth/assets/sso-microsoft.svg.

import type { SVGProps } from 'react';

export function SsoMicrosoftIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      role="img"
      aria-label="Microsoft"
      {...props}
    >
      <rect x="0" y="0" width="6" height="6" fill="#F25022" />
      <rect x="8" y="0" width="6" height="6" fill="#7FBA00" />
      <rect x="0" y="8" width="6" height="6" fill="#00A4EF" />
      <rect x="8" y="8" width="6" height="6" fill="#FFB900" />
    </svg>
  );
}
